<template>
    <div class="slider-blog">
        <h3 class="font-balo title-slider-blog" :style="{ color: blog.color }">
            {{ blog.name }}
        </h3>
        <slick
            :options="slickOptions"
            tag="div"
            class="row list-slider-post"
            v-if="blog.posts.length > 0"
        >
            <div
                class="it-post"
                v-for="(post, index) in blog.posts"
                :key="index"
            >
                <div
                    class="feature-blog"
                    :style="{ backgroundImage: `url(${post.image})` }"
                >
                    <router-link :to="`/blog/${post.ID}`"></router-link>
                </div>
                <div class="description-blog">
                    <h3>
                        <router-link :to="`/blog/${post.ID}`">{{
                            post.title
                        }}</router-link>
                    </h3>
                    <p v-html="post.content"></p>
                    <div class="time-post" v-if="post.date">
                        {{ post.date }}
                    </div>
                </div>
            </div>
        </slick>
        <div class="btn-view-post text-center">
            <a
                :style="{ backgroundColor: blog.color }"
                href="#"
                class="font-balo"
                >{{ $t("app.View all") }}</a
            >
        </div>
    </div>
</template>

<script>
import Slick from "vue-slick";
export default {
    name: "BlogSlide",
    props: ["blog"],
    components: { Slick },
    // mounted() {
    //     console.log(this.blog);
    // },
    data() {
        return {
            slickOptions: {
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        };
    }
};
</script>
